import * as mappers from '../config/mappers';

export class MapperFactory {
    build(className: string) {
        return new mappers[className as keyof typeof mappers]();
    }
}
